import { useQuery } from '@tanstack/react-query';
import { AllCustomFieldsResponse } from '../../../types/EventTemplate';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type UseGetAllCustomFieldsProps = {
  enabled?: boolean;
};

export const fetchAllCustomFields = async () => {
  const response = await CustomAxios.get<AllCustomFieldsResponse>(`event_templates/field_names`);
  const { data } = response;
  return data;
};

export function useGetAllCustomFields({ enabled = true }: UseGetAllCustomFieldsProps) {
  const queryKey = [queryKeys.allCustomFields];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllCustomFields(),
  });
  return query;
}
